/*
 * @Author: your name
 * @Date: 2020-06-29 16:28:35
 * @LastEditTime: 2020-06-29 16:47:22
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \heating-wechat-web\src\public\server.js
 */ 
import axios from 'axios';
import {
  Message
} from 'element-ui';
import router from '../router';
const Axios = axios.create({
  baseURL: '',
  timeout: 30000,
  responseType: 'json',
  withCredentials: false, // 是否允许带cookie这些
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
});
// 添加请求拦截器
Axios.interceptors.request.use(
  (config) => { // 在发送请求之前做些什么
    if (config.method === 'get') {
      config.params = config.data;
    }
    if (sessionStorage.getItem('access_token')) {
      config.url = config.url + '?access_token=' + sessionStorage.getItem('access_token');
    }
    return config;
  }, (error) => { // 对请求错误做些什么
    Message({
      showClose: true,
      message: error,
      type: 'error.data.error.message',
    });
    return Promise.reject(error);
  },
);
// 添加响应拦截器
Axios.interceptors.response.use(
  res => {
    if (!res.data.code || res.data.code == 200) {
      return res.data;
    } else {
      if (res.data.code == 400) {
        Message({
          showClose: true,
          message: '请求超时，请重新请求',
          type: 'error'
        });
        return Promise.reject(res.data);

      }
      else if (res.data.code == 400003) {
        if (router.currentRoute.path !== '/') {
          router.push('/');
        }

      }
      else if (res.data.code !== 200) {
        Message({
          showClose: true,
          message: res.data.error ? res.data.error : res.data.message,
          type: 'error'
        });
        return Promise.reject(res.data);
      }
    }
    return null;
  });

export default Axios;